import client from "./axiosConfig";

export const getBills = (params) => {
  const config = {
    url: "/bill_manager/bills/",
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getBillById = (id) => {
  const config = {
    url: `/bill_manager/bills/${id}`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const createBill = (data) => {
  const config = {
    url: `/bill_manager/bills/`,
    method: "POST",
    data
  };
  const response = client(config);
  return response;
};

export const updateBill = (id) => {
  const config = {
    url: `/bill_manager/bills/${id}`,
    method: "PATCH",
  };
  const response = client(config);
  return response;
};

export const fetchCategories = (params) => {
  const config = {
    url: "/bill_manager/bill-category/",
    method: "GET",
    params
  };
  const response = client(config);
  return response
}

export const updateBillStatus = (id, data) => {
  const config = {
    url: `/bill_manager/bills/${id}/review/`,
    method: "PATCH",
    data
  }
  return client(config);
}

export const deleteBill = (id) => {
  const config = {
    url: `/bill_manager/bills/${id}/`,
    method: "DELETE"
  }
  return client(config);
}